import React, {useEffect, useState} from 'react';
import {Container} from "../../ui/Container";
import {Card, FormControlLabel, Radio} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useFormik} from "formik";
import {AppField} from "../../ui/AppField";
import {AppButton} from "../../ui/AppButton";
import {object, string} from "yup";
import {useI18n} from "../../../i18n/I18nContext";
import {useParams} from "react-router";
import {useIntegrationsContext} from "../../../api/integrations/IntegrationsContext";
import {showError} from "../../../utils/NotificationUtils";
import {IntegrationAuthFieldProps} from "../../../api/integrations/IntegrationsDTO";
import {Loader} from "../../ui/Loader";

const validationSchema = (translate: any) => object({
    label: string().required(translate("REQUIRED")),
    code: string().required(translate("REQUIRED")),
    description: string(),
    defaultValue: string(),
    type: string(),
    required: string(),
});


const useStyles = makeStyles(() => ({
    root: {
        padding: 24
    },
    cardRoot: {
        padding: 24,
        borderRadius: "16px !important" as any
    },
    formTitle: {
        fontSize: 18,
        lineHeight: "21px",
        fontWeight: 700,
        color: "#000",
        marginBottom: 16
    },
    fieldRoot: {
        marginBottom: 24
    }
}));


interface Props {
    readonly isAdd: boolean
}

export function IntegrationEditAuthFields({isAdd}: Props) {
    const classes = useStyles();
    const {translate} = useI18n();
    const params: any = useParams();
    const {IntegrationsApi} = useIntegrationsContext();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<IntegrationAuthFieldProps>();

    useEffect(() => {
        if (!isAdd) {
            IntegrationsApi.getIntegrationAuthField({params: {fieldId: params.fieldId}}).then((res) => {
                setData(res.payload);
                setLoading(false);

            }).catch(err => {
                showError(err);
                setLoading(false);
            })
        }
    }, [params, IntegrationsApi, isAdd]);


    const formik = useFormik({
        initialValues: {
            code: data?.code,
            defaultValue: data?.defaultValue,
            description: data?.description,
            label: data?.label,
            required: data?.required,
            type: data?.type
        },
        validationSchema: validationSchema(translate),
        onSubmit: (values) => console.log(values),
        enableReinitialize: true
    });

    return (
        <div className={classes.root}>
            {loading ? (
                <Loader />
            ) : (
                <Container>
                <Card className={classes.cardRoot}>
                    <h2 className={classes.formTitle}>Add Field</h2>
                    {/*<IntegrationCreateForm/>*/}
                    <form onSubmit={formik.handleSubmit}>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                required={true}
                                variant="outlined"
                                labelText="Label"
                                name="label"
                                id="label"
                                error={formik.touched.label && Boolean(formik.errors.label)}
                                helperText={formik.touched.label && formik.errors.label}
                                value={formik.values.label}
                                onChange={formik.handleChange}
                                helpDesc="Enter the field's friendly name for users."
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                required={true}
                                variant="outlined"
                                labelText="Code"
                                name="code"
                                id="code"
                                error={formik.touched.code && Boolean(formik.errors.code)}
                                helperText={formik.touched.code && formik.errors.code}
                                value={formik.values.code}
                                onChange={formik.handleChange}
                                helpDesc="Add the field key, for example: api_key."
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                variant="outlined"
                                labelText={translate("DESCRIPTION")}
                                name="description"
                                id="description"
                                error={formik.touched.description && Boolean(formik.errors.description)}
                                helperText={formik.touched.description && formik.errors.description}
                                value={formik.values.description}
                                onChange={formik.handleChange}
                                helpDesc="Explain to users what to include in this field, especially for API keys and other hard to find info. Include directions to find the data and links to your app settings or help docs"
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                variant="outlined"
                                labelText="Default Value"
                                name="defaultValue"
                                id="defaultValue"
                                error={formik.touched.defaultValue && Boolean(formik.errors.defaultValue)}
                                helperText={formik.touched.defaultValue && formik.errors.defaultValue}
                                value={formik.values.defaultValue}
                                onChange={formik.handleChange}
                                helpDesc="Explain to users what to include in this field, especially for API keys and other hard to find info. Include directions to find the data and links to your app settings or help docs"
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                variant="outlined"
                                labelText="Type"
                                name="type"
                                id="type"
                                error={formik.touched.type && Boolean(formik.errors.type)}
                                helperText={formik.touched.type && formik.errors.type}
                                value={formik.values.type}
                                onChange={formik.handleChange}
                                helpDesc="Explain to users what to include in this field, especially for API keys and other hard to find info. Include directions to find the data and links to your app settings or help docs"
                            />
                        </div>
                        <FormControlLabel value={true} name="required" control={<Radio/>} label="Required ?"/>
                        <AppButton type="submit">Save</AppButton>
                    </form>
                </Card>
            </Container>
            )}
        </div>
    );
}